import { installSafeArborist } from './arborist/index.mts'

installSafeArborist()
